module.exports = __webpack_public_path__ + "static/media/7.c016ede0.jpg";